import { getMessageDefinitions, getMessageDefinitionByType } from '@k-ucap/message-dictionary';
import type { MessageDefinition, MessageDefinitionRepository } from './RepositoryInterfaces.js';

export class InMemoryMessageDefinitionRepository implements MessageDefinitionRepository {
  private definitions: Map<string, MessageDefinition> = new Map();
  private byType: Map<number, MessageDefinition> = new Map();

  constructor(definitions: MessageDefinition[] = getMessageDefinitions()) {
    definitions.forEach((d) => {
      this.definitions.set(d.id, d);
      this.byType.set(d.messageType, d);
    });
  }

  async findAll(): Promise<MessageDefinition[]> {
    return Array.from(this.definitions.values());
  }

  async findByType(messageType: number): Promise<MessageDefinition | undefined> {
    return this.byType.get(messageType) ?? getMessageDefinitionByType(messageType);
  }

  async findById(id: string): Promise<MessageDefinition | undefined> {
    return this.definitions.get(id);
  }

  async save(def: MessageDefinition): Promise<MessageDefinition> {
    this.definitions.set(def.id, def);
    this.byType.set(def.messageType, def);
    return def;
  }
}

export const createInMemoryMessageDefinitionRepository = (): InMemoryMessageDefinitionRepository =>
  new InMemoryMessageDefinitionRepository();
